<template>
    <div class="flex flex-col md:flex-row gap-4 flex-wrap">
        <div
            class="flex-1 min-w-60 border-solid rounded-xl border-t-20 border-lightblue bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/pediatric/stethoscope.svg" alt="Stethoscope icon" />

            <h5 class="text-2xl mb-9 text-center">Physical examination</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>The patient is a small-for-age girl with weight of 19.1 kg (&lt;3<sup>rd</sup> centile) and height of 126 cm (between 25th and 50th centile)</li>
                <li>Vital signs were stable apart from having hypertension with blood pressure of 124/82 mmHg</li>
                <li>The patient was pale and sallow with facial puffiness, but no edema was detected elsewhere</li>
                <li>Abdominal palpation identified some left flank tenderness, otherwise it was soft, with no ballotable kidneys</li>
                <li>Cardiovascular and respiratory examination was unremarkable</li>
            </ul>
        </div>

        <div
            class="flex-1 min-w-60 border-solid rounded-xl border-t-20 border-maroon bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/graphics/pediatric/beaker-maroon.png" alt="Beaker icon" />

            <h5 class="text-2xl text-center mb-10">Blood work</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>Severe normocytic normochromic anemia with  hemoglobin 5.3 g/dL, total white blood cell count 6300/μL, and platelet count 200,000/μL</li>
            </ul>
        </div>

        <div
            class="flex-1 min-w-60 border-solid rounded-xl border-t-20 border-darkerblue bg-grey p-6 flex flex-col items-center gap-3"
        >
            <img src="@/assets/img/kidneys.svg" alt="Kidneys icon" />

            <h5 class="text-2xl text-center">Urinalysis, urine cultures, and blood cultures</h5>

            <ul class="list-disc pl-4 font-light self-start">
                <li>Negative urine culture</li>
            </ul>

        </div>
    </div>
</template>
